import { useParams } from "react-router-dom";
import { isTaskSetGeoLocation } from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import NotFound from "@/routes/Pages/NotFound";

import { SendGeoPage } from "./SendGeoPage";

const SendGeo = () => {
    const { marketId, taskId } = useParams();

    const { tasks, markets } = useAppSelector((state) => state.work);

    const safeMarketId = marketId ?? "";
    const safeTaskId = taskId ?? "";

    if (!safeMarketId || !safeTaskId) return null;

    const currentTask = tasks?.[marketId]?.[taskId];
    const currentMarket = markets?.[marketId];

    if (!currentTask || !isTaskSetGeoLocation(currentTask) || !currentMarket) {
        return <NotFound />;
    }

    return <SendGeoPage market={currentMarket} task={currentTask} />;
};

export default SendGeo;
